/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgComparativeTrendAnalysis = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m4 13.414 6-6 4 4 7.707-7.707-1.414-1.414L14 8.586l-4-4-6 6V2H2v20h20v-2H4.329l5.637-6.442 3.728 4.66 7.7-3.299-.788-1.838-6.3 2.7-4.272-5.339L4 17.34z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgComparativeTrendAnalysis as ComparativeTrendAnalysis };
